import NextImage from '@/components/Image';
import Styled from '@/components/modules/ProductOverview/components';
import { FC } from 'react';

interface ProductOverviewProps {
  heading?: string;
}

const ProductOverview: FC<ProductOverviewProps> = (props) => {
  return (
    <Styled.Wrapper>
      {props.heading && <Styled.Heading id="product-overview-heading">{props.heading}</Styled.Heading>}

      <Styled.ProductImage>
        <NextImage
          src="/staticwebassets/modules/productoverview/universal-inbox-v2.png"
          width={2400}
          height={1264}
          alt=""
        />
      </Styled.ProductImage>
    </Styled.Wrapper>
  );
};

export default ProductOverview;
